import React from 'react';
import {
  SPLIT_SEPARATORS,
  Action,
  withInject,
} from '@piwikpro/platform';
import { FormValidator } from '@piwikpro/form-crate';
import { Card, withTranslation } from '@piwikpro/ui-components';
import { TrackerSettings } from '../../../TrackerSettings';

export interface CampaignKeywordParamsProps {
  globalAndAppTrackerSettings: Array<string | object>
  trackerSettings: TrackerSettings
  t: (key: string) => string
  validation: FormValidator
  appId: string
}

class CampaignKeywordParams extends React.Component<CampaignKeywordParamsProps> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter(element => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        globalAndAppTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      globalAndAppTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <Card.Section>
        <Action.AutoSavedTagsInputControl
          id="app-settings-campaign-keyword-params"
          label={t('apps.details.settings.campaignKeywordParams.title')}
          info={t('components:tagsInput.placeholder.default')}
          name="campaign_keyword_params"
          initialValue={globalAndAppTrackerSettings}
          validationSchema={validation.createValidationSchema(validators => ({
            campaign_keyword_params: validators.trackerSettings.campaignKeywordParams,
          }))}
          splitSeparators={SPLIT_SEPARATORS}
          onSubmit={this.handleSubmit}
        />
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(CampaignKeywordParams as any),
);
